// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"38":"6640c415edb04352","655":"e9e74c11b0871ff7"}[chunkId] + ".js";
};